<template>
    <div class="modal is-active"  >
        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title " v-if="mode =='I'" >New Insert Mode </p>
                <p class="modal-card-title " v-if="mode =='U'" >Edit Mode</p>
         
            </header>
            <section class="modal-card-body">
         
                <b-field label="Blood Morphology "
                    :type="{ 'is-danger': hasEmptyName }"
                    :message="{ 'please some text': hasEmptyName }"
                              
                              >
                    <b-input v-model="dataBlmorToEdit.name" >{{dataBlmorToEdit.name}}</b-input>
                </b-field>
                <b-field label="Status">
                    <b-switch  type="is-success" v-model=" dataBlmorToEdit.enable "
                            ></b-switch>
                </b-field>
                
            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  @click="closeBtn">Cancel</b-button>
                <b-button type="is-success" :disabled="hasEmptyName" @click="save">Save</b-button>
            </footer>
        </div>
    </div>
</template>


<script>

import axios from "axios";    /* eslint-disable */
import {  getBaseURLforBackEnd , getConfigAxios , genUUID }  from '@/utils.js'
import { mapState } from "vuex";




export default {
    name : "AddEditBlMor",
    props:{
      dataBlmorToEdit : Object,
      mode : String,
    },
    computed:{
            ...mapState({
                access_token : state => state.master_data.access_token,
            }) ,
    },
    methods:{
        save(){
          // check empty bl. mor name    
          if(!this.dataBlmorToEdit.name){
            this.hasEmptyName = true
            return
          }

          // else ---> pass   
                //   console.log("ok")
                let datTo ={}
                let endPoint = ''
                if(this.mode == 'I'){
                    datTo = {
                             "name" :  this.dataBlmorToEdit.name,
                             "enable" : this.dataBlmorToEdit.enable
                            }
                    endPoint = 'add_new_blmor'        
                }else if(this.mode == 'U'){
                    datTo = {
                            "id" : this.dataBlmorToEdit.id,
                            "name" :  this.dataBlmorToEdit.name,
                            "enable" : this.dataBlmorToEdit.enable
                            }
                    endPoint = 'update_blmor'         
                }

            // console.log(JSON.stringify(datTo))

                this.isLoadingFullPage = true
                axios.defaults.headers.common['Authorization'] =  `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`, datTo, getConfigAxios())
                    .then((res)=>{
                        this.$buefy.toast.open({
                                duration: 2500,
                                message: `${res.data.msg}`,
                                position: 'is-bottom',
                                type: 'is-success'
                            })
                        this.isLoadingFullPage = false
                        this.$emit('closeWithDataChange')
                      
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        this.isLoadingFullPage = false
                    })




        },
        closeBtn(){
            this.$emit('close')
        }
    },
    data(){
        return {
            isFullScreenSearching : false,
            hasEmptyName : false,
        }
    },
    watch:{
        'dataBlmorToEdit.name' :{
            deep : true,
            handler: function(val){
                //  if(!val){
                //     this.hasEmptyName = true
                //  }else{
                //     this.hasEmptyName = false
                //  }

                  this.hasEmptyName = !val
            }
        }
    }
}
</script>